import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
          <img src="img/logo.png" className="img-responsive" id="logo"alt="" />{" "}
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
              <i id="icons"class="fa fa-circle-o" aria-hidden="true"></i>
              Benefícios
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
              <i id="icons"class="fa fa-circle-o" aria-hidden="true"></i>

              Sobre
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
              <i id="icons"class="fa fa-circle-o" aria-hidden="true"></i>

              Clube
              </a>
            </li>
            <li>
              <a href="#doctors" className="page-scroll">
              <i id="icons" class="fa fa-circle-o" aria-hidden="true"></i>

              Médicos
              </a>
            </li>
            <li>
              <a href="#family" className="page-scroll">
              <i id="icons"class="fa fa-circle-o" aria-hidden="true"></i>

              Para Você
              </a>
            </li>
            <li>
              <a href="#inovation" className="page-scroll">
              <i id="icons"class="fa fa-circle-o" aria-hidden="true"></i>

              Inovação
              </a>
            </li>
    
            <li>
              <a href="#cabine" className="page-scroll">
              <i id="icons" class="fa fa-circle-o" aria-hidden="true"></i>
              Dispositivos
              </a>
            </li>

            <li>
              <a href="#business" className="page-scroll">
              <i id="icons" class="fa fa-circle-o" aria-hidden="true"></i>

              Contato
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
